import React, { useState, useEffect } from "react";
import "./BlogsForm.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addBlogs,
  UploadBlogBodyImage,
  BlogCategoryDrop,
  UploadFeatureImageUrl,
  getProjects,
} from "proxyUrl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsFillImageFill } from "react-icons/bs";

// Store alt text temporarily for image insertion
let pendingAltText = null;
// Store nofollow flag temporarily for link insertion
let pendingNofollow = null;

// Custom upload adapter class for CKEditor (body images)
class CustomUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then((file) => {
      return new Promise((resolve, reject) => {
        // Prompt for alt text (same behaviour as provided example)
        const altText = window.prompt(
          "Enter alt text for the image (optional):"
        );
        pendingAltText = altText || null;

        const formData = new FormData();
        // CKEditor body image upload endpoint in this project expects "upload"
        formData.append("upload", file);

        const xhr = new XMLHttpRequest();
        xhr.open("POST", UploadBlogBodyImage, true);
        xhr.withCredentials = true;

        xhr.onload = () => {
          if (xhr.status === 200 || xhr.status === 201) {
            try {
              const response = JSON.parse(xhr.responseText);
              // Support multiple possible response shapes
              const fileUrl =
                response.url || response.imageUrl || response.fileUrl;
              if (fileUrl) {
                resolve({
                  default: fileUrl,
                });
              } else {
                toast.error("Error uploading image");
                reject(new Error("Upload failed: No URL in response"));
              }
            } catch (error) {
              console.error("Error parsing upload response:", error);
              toast.error("Error uploading image");
              reject(new Error("Upload failed: Invalid response"));
            }
          } else {
            console.error("Upload failed:", xhr.status, xhr.statusText);
            toast.error("Error uploading image");
            reject(new Error(`Upload failed: ${xhr.statusText}`));
          }
        };

        xhr.onerror = () => {
          toast.error("Error uploading image");
          reject(new Error("Upload failed"));
        };

        xhr.send(formData);
      });
    });
  }

  abort() {
    // Handle abort if needed
  }
}

const BlogsForm = () => {
  const [content, setContent] = useState();
  const [image, setImage] = useState({});
  const [submiteed, setSubmiteed] = useState(false);
  const [status, setStatus] = useState("1");
  const [preview, setPreview] = useState(null);
  const [categoryDataApi, setCategoryData] = useState("");
  const [catDropData, setCatDropData] = useState("");
  const [type, setType] = useState();

  const [products, setProducts] = useState([]);
  console.log(catDropData, 76543);
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const getProductsData = async () => {
    await axios
      .get(getProjects)
      .then((res) => {
        setProducts(res.data.data);
      })
      .catch((err) => {
        console.log(err);
        setProducts([]);
      });
  };
  useEffect(() => {
    getProductsData();
  }, []);

  const handleTypeChange = (event) => {
    setType(event.target.value);
  };

  const handleCategoryChange = (event) => {
    setCatDropData(event.target.value);
  };
  const handleImage = (e) => {
    setImage(e.target.files[0]);
    setPreview(URL.createObjectURL(e.target.files[0]));
  };
  const getCatData = async () => {
    await axios.get(BlogCategoryDrop).then((res) => {
      console.log(res.data, 658755);
      setCategoryData(res.data);
    });
  };
  const navigate = useNavigate();
  const [user, setUser] = useState({
    title: "",
    metadescription: "",
    slug: "",
    metakeywords: "",
    metatitle: "",
    alttext: "",
    canonical: "",
    shortDescription: "",
  });
  let name, value;
  const handleInput = (e) => {
    // console.log(e);

    name = e.target.name;
    value = e.target.value;

    setUser({ ...user, [name]: value });
  };

  //Setting the title as slug bu default

  useEffect(() => {
    setUser({ ...user, slug: user.title });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.title])

  const sendData = async (e) => {
    e.preventDefault();
    setSubmiteed(true);
    if (
      !user.alttext ||
      !user.canonical ||
      !user.metakeywords ||
      !user.metadescription ||
      !user.slug ||
      !user.title ||
      !image ||
      !type
    ) {
      toast.error("please  the data!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    //creating form data
    const formData = new FormData();
    formData.append("image", image);

    await axios
      .post(UploadFeatureImageUrl, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          axios
            .post(
              addBlogs,
              {
                title: user.title,
                category: catDropData,
                slug: user.slug,
                content: content,
                metakeywords: user.metakeywords,
                metadescription: user.metadescription,
                metatitle: user.metatitle,
                alttext: user.alttext,
                canonical: user.canonical,
                shortDescription: user.shortDescription,
                status: status,
                image: res.data.imageUrl,
                type: type,
              },
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              console.log(res.status);
              if (res.status === 200) {
                console.log("Form submiteed succsesfully");
                toast.success("Form submiteed succsesfully!", {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                const delayfrfresh = () => {
                  navigate("/admin/blogs");
                };
                // eslint-disable-next-line
                const delayRef = setTimeout(delayfrfresh, 3100);
              }
            })
            .catch((err) => {
              console.log(err.response.status);
              if (err.response.status === 400) {
                console.log("Please fill all data");
                toast.error("Please fill all data!", {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                const delay = () => {
                  setSubmiteed(false);
                };
                // eslint-disable-next-line
                const myTimeout = setTimeout(delay, 3000);
              } else {
                console.log("something went wrong");
                toast.error("something went wrong!", {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                const delay = () => {
                  setSubmiteed(false);
                };
                // eslint-disable-next-line
                const myTimeout = setTimeout(delay, 3000);
              }
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const tork = false;
  const [userPlace, setUserPlace] = useState({
    title: "Enter Blog Title",
    metadescription: "Enter Blog Meta Descrioption ",
    slug: "Enter Blog  slug ",
    content: "Enter Blog Content",
    metakeywords: "Enter Blog Metakeywords",
    metatitle: "Enter Blog Metatitle",
    alttext: "Enter Blog Alttext",
    canonical: "Enter Blog Canonical",
    Description: "Type Hare....",
  });

  if (tork === true) {
    setUserPlace(null);
  }

  useEffect(() => {
    getCatData();
  }, [image]);
  return (
    <>
      <div className="mt-7  mb-2 rounded-lg bg-white shadow-xl dark:bg-navy-800 ">
        <div className="mx-auto w-[90%]  ">
          <form action="" method="POST" className="">
            <div className="">
              <div className="field w-[100%] ">
                <div className="input  relative">
                  <label htmlFor="title"> Title</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.title}`}
                    maxLength={80}
                    name="title"
                    value={user.title}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative">
                  <label htmlFor="slug" className="">
                    Slug
                  </label>
                  <input
                    type="text"
                    placeholder={`${userPlace.slug}`}
                    name="slug"
                    value={user.slug}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <div className="field">
                <div className="input relative">
                  <label htmlFor="metakeywords"> Metakeywords</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.metakeywords}`}
                    name="metakeywords"
                    value={user.metakeywords}
                    onChange={handleInput}
                  />
                </div>
                <div className="input  relative ">
                  <label htmlFor="Metatitle"> Metatitle</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.metatitle}`}
                    name="metatitle"
                    value={user.metatitle}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <div className="field">
                <div className="input relative ">
                  <label htmlFor="category"> Meta Description</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.metadescription}`}
                    name="metadescription"
                    value={user.metadescription}
                    onChange={handleInput}
                  />
                </div>

                <div className="input  relative ">
                  <label htmlFor="canonical">Canonical</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.canonical}`}
                    name="canonical"
                    value={user.canonical}
                    onChange={handleInput}
                  />
                </div>
              </div>

              <div className="field">
                <div className="input relative">
                  <label htmlFor="alttext"> Alttext</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.alttext}`}
                    name="alttext"
                    maxLength={80}
                    value={user.alttext}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative">
                  <label htmlFor="shortDescription">Short Description</label>
                  <input
                    className="h-[53px] overflow-hidden !rounded-md   "
                    id="shortDescription"
                    type="text"
                    value={user.shortDescription}
                    onChange={handleInput}
                    name="shortDescription"
                  />
                </div>
              </div>
              <div className="field">
                <div className="input relative">
                  <label htmlFor="status-select">Status:</label>
                  <select
                    id="status-select"
                    value={status}
                    onChange={handleStatusChange}
                  >
                    <option value="1">Active</option>
                    <option value="0">Disabled</option>
                  </select>
                </div>
                <div className="input relative">
                  <label htmlFor="status-select">Category:</label>
                  <select
                    id="status-select"
                    value={catDropData}
                    onChange={handleCategoryChange}
                    className=" capitalize"
                  >
                    {categoryDataApi
                      ? categoryDataApi.map((data, index) => {
                        return (
                          <option
                            className=" capitalize"
                            key={index}
                            value={data.value}
                          >
                            {data.name}
                          </option>
                        );
                      })
                      : ""}
                  </select>
                </div>
                {/*  */}
                <div className="input relative">
                  <label htmlFor="status-select">Type:</label>
                  <select
                    id="status-select"
                    value={type}
                    onChange={handleTypeChange}
                  >
                    <option value="">Select</option>
                    {products[0] ? (
                      <>
                        {products.map((value, index) => {
                          return (
                            <>
                              <option key={index} value={value.id}>
                                {" "}
                                {value.name}{" "}
                              </option>
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <option value="creedinfotech">no data</option>
                      </>
                    )}
                  </select>
                </div>
                {/*  */}
              </div>
              <div className="field my-6">
                <div className="input relative mx-2 mr-7 flex items-center justify-center rounded-lg border-2 border-blueSecondary   ">
                  <div className=" h-[200px] w-[400px] rounded-lg ">
                    {preview ? (
                      <img
                        className="h-full w-full rounded-md object-cover "
                        src={preview}
                        alt=""
                      />
                    ) : (
                      <>
                        <div className=" flex h-full w-full items-center justify-center text-8xl text-primaryBlue ">
                          <BsFillImageFill />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="input relative">
                  <label htmlFor="alttext">Uploade File</label>
                  <input
                    type="file"
                    name="file"
                    // value={user.alttext}
                    onChange={handleImage}
                  />
                </div>
              </div>
              <div className="relative mx-2">
                <h2 className="mb-1"> Content</h2>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    licenseKey: "GPL",
                    toolbar: [
                      "heading",
                      "|",
                      "fontFamily",
                      "fontSize",
                      "|",
                      "bold",
                      "italic",
                      "underline",
                      "strikethrough",
                      "|",
                      "fontColor",
                      "fontBackgroundColor",
                      "|",
                      "subscript",
                      "superscript",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "|",
                      "indent",
                      "outdent",
                      "|",
                      "alignment",
                      "|",
                      "blockQuote",
                      "codeBlock",
                      "|",
                      "link",
                      "imageUpload",
                      "mediaEmbed",
                      "|",
                      "insertTable",
                      "|",
                      "undo",
                      "redo",
                    ],
                    heading: {
                      options: [
                        {
                          model: "paragraph",
                          title: "Paragraph",
                          class: "ck-heading_paragraph",
                        },
                        {
                          model: "heading1",
                          view: "h1",
                          title: "Heading 1",
                          class: "ck-heading_heading1",
                        },
                        {
                          model: "heading2",
                          view: "h2",
                          title: "Heading 2",
                          class: "ck-heading_heading2",
                        },
                        {
                          model: "heading3",
                          view: "h3",
                          title: "Heading 3",
                          class: "ck-heading_heading3",
                        },
                        {
                          model: "heading4",
                          view: "h4",
                          title: "Heading 4",
                          class: "ck-heading_heading4",
                        },
                        {
                          model: "heading5",
                          view: "h5",
                          title: "Heading 5",
                          class: "ck-heading_heading5",
                        },
                        {
                          model: "heading6",
                          view: "h6",
                          title: "Heading 6",
                          class: "ck-heading_heading6",
                        },
                      ],
                    },
                    table: {
                      contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
                    },
                  }}
                  data={content}
                  onReady={(editor) => {
                    // Configure upload adapter
                    editor.plugins.get("FileRepository").createUploadAdapter = (
                      loader
                    ) => {
                      return new CustomUploadAdapter(loader);
                    };

                    // Configure link schema to allow rel attribute
                    const schema = editor.model.schema;

                    if (schema.isRegistered("link")) {
                      schema.extend("link", {
                        allowAttributes: ["rel"],
                      });
                    }

                    // Ensure imageBlock allows alt attribute
                    if (schema.isRegistered("imageBlock")) {
                      schema.extend("imageBlock", {
                        allowAttributes: ["alt"],
                      });
                    }

                    // Configure conversion to preserve rel attribute in HTML output
                    const conversion = editor.conversion;

                    // rel on links - downcast
                    conversion.for("dataDowncast").attributeToAttribute({
                      model: {
                        name: "link",
                        key: "rel",
                      },
                      view: {
                        name: "a",
                        key: "rel",
                      },
                    });

                    // rel on links - upcast
                    conversion.for("upcast").attributeToAttribute({
                      view: {
                        name: "a",
                        key: "rel",
                      },
                      model: {
                        name: "link",
                        key: "rel",
                      },
                    });

                    // alt on images
                    conversion.for("dataDowncast").attributeToAttribute({
                      model: {
                        name: "imageBlock",
                        key: "alt",
                      },
                      view: {
                        name: "img",
                        key: "alt",
                      },
                    });

                    // Intercept link command to add dofollow/nofollow functionality
                    const linkCommand = editor.commands.get("link");
                    if (linkCommand) {
                      const originalExecute = linkCommand.execute.bind(linkCommand);

                      linkCommand.execute = (url, attributes) => {
                        const followType = window.confirm(
                          "Click OK for dofollow link, Cancel for nofollow link"
                        );
                        pendingNofollow = !followType;

                        return originalExecute(url, attributes);
                      };
                    }

                    // Listen for document changes to apply alt text and nofollow links
                    editor.model.document.on("change:data", () => {
                      const model = editor.model;

                      // Handle pending alt text for images
                      if (pendingAltText !== null) {
                        setTimeout(() => {
                          const root = model.document.getRoot();
                          const differ = model.document.differ;
                          const changes = differ.getChanges({
                            includeChangesInGraveyard: false,
                          });

                          let imageElement = null;

                          // Try to find most recently inserted image
                          for (let i = changes.length - 1; i >= 0; i--) {
                            const change = changes[i];
                            if (
                              change.type === "insert" &&
                              change.name === "imageBlock"
                            ) {
                              imageElement = change.position.nodeAfter;
                              break;
                            }
                          }

                          // If not found, search all images without alt
                          if (!imageElement) {
                            const range = model.createRangeIn(root);
                            for (const value of range.getWalker()) {
                              const item = value.item;
                              if (item.is("element", "imageBlock")) {
                                const alt = item.getAttribute("alt");
                                if (!alt || alt === "") {
                                  imageElement = item;
                                  break;
                                }
                              }
                            }
                          }

                          if (imageElement) {
                            model.change((writer) => {
                              writer.setAttribute(
                                "alt",
                                pendingAltText || "",
                                imageElement
                              );
                            });
                          }

                          pendingAltText = null;
                        }, 150);
                      }

                      // Handle pending nofollow for links
                      if (pendingNofollow !== null) {
                        setTimeout(() => {
                          const model = editor.model;
                          const root = model.document.getRoot();
                          const selection = model.document.selection;
                          const range = selection.getFirstRange();
                          const differ = model.document.differ;
                          const changes = differ.getChanges({
                            includeChangesInGraveyard: false,
                          });

                          let linkElement = null;

                          // Use differ to find recently inserted/modified link
                          for (let i = changes.length - 1; i >= 0; i--) {
                            const change = changes[i];

                            if (
                              change.type === "insert" &&
                              change.name === "link"
                            ) {
                              linkElement = change.position.nodeAfter;
                              break;
                            }

                            if (
                              change.type === "insert" &&
                              change.name === "$text"
                            ) {
                              let parent = change.position.parent;
                              while (parent) {
                                if (parent.is("element", "link")) {
                                  linkElement = parent;
                                  break;
                                }
                                parent = parent.parent;
                              }
                              if (linkElement) break;
                            }

                            if (
                              change.type === "attribute" &&
                              change.attributeKey === "linkHref"
                            ) {
                              const position = change.range.start;
                              let item =
                                position.nodeAfter || position.parent;
                              while (item) {
                                if (item.is("element", "link")) {
                                  linkElement = item;
                                  break;
                                }
                                item = item.parent;
                              }
                              if (linkElement) break;
                            }
                          }

                          // If not found in changes, check current selection
                          if (!linkElement && range) {
                            let item =
                              range.start.nodeAfter || range.start.parent;
                            while (item) {
                              if (item.is("element", "link")) {
                                linkElement = item;
                                break;
                              }
                              item = item.parent;
                            }

                            if (!linkElement) {
                              for (const value of range.getWalker()) {
                                const wItem = value.item;
                                if (wItem.is("element", "link")) {
                                  linkElement = wItem;
                                  break;
                                }

                                let parent = wItem.parent;
                                while (parent) {
                                  if (parent.is("element", "link")) {
                                    linkElement = parent;
                                    break;
                                  }
                                  parent = parent.parent;
                                }

                                if (linkElement) break;
                              }
                            }
                          }

                          // If still not found, search all links
                          if (!linkElement) {
                            const docRange = model.createRangeIn(root);
                            for (const value of docRange.getWalker()) {
                              const item = value.item;
                              if (item.is("element", "link")) {
                                const currentRel = item.getAttribute("rel");
                                if (!currentRel || currentRel === "") {
                                  linkElement = item;
                                  break;
                                }
                              }
                            }
                            if (!linkElement) {
                              const fullRange = model.createRangeIn(root);
                              for (const value of fullRange.getWalker()) {
                                const item = value.item;
                                if (item.is("element", "link")) {
                                  linkElement = item;
                                  break;
                                }
                              }
                            }
                          }

                          // Apply or remove rel attribute
                          if (linkElement) {
                            const shouldBeNofollow = pendingNofollow === true;
                            model.change((writer) => {
                              if (shouldBeNofollow) {
                                writer.setAttribute(
                                  "rel",
                                  "nofollow",
                                  linkElement
                                );
                              } else {
                                const currentRel =
                                  linkElement.getAttribute("rel");
                                if (currentRel) {
                                  writer.removeAttribute("rel", linkElement);
                                }
                              }
                            });
                          }

                          pendingNofollow = null;
                        }, 150);
                      }
                    });
                  }}
                  onChange={(_, editor) => {
                    let html = editor.getData();

                    // Post-process HTML to ensure rel and alt attributes are preserved
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    const model = editor.model;
                    const root = model.document.getRoot();
                    const range = model.createRangeIn(root);

                    // Links
                    const links = doc.querySelectorAll("a[href]");
                    const modelLinks = new Map();

                    for (const value of range.getWalker()) {
                      const item = value.item;
                      if (item.is("element", "link")) {
                        const href = item.getAttribute("href");
                        const rel = item.getAttribute("rel");
                        if (href) {
                          modelLinks.set(href, rel || null);
                        }
                      }
                    }

                    links.forEach((link) => {
                      const href = link.getAttribute("href");
                      const modelRel = modelLinks.get(href);
                      if (modelRel) {
                        link.setAttribute("rel", modelRel);
                      } else {
                        link.removeAttribute("rel");
                      }
                    });

                    // Images
                    const images = doc.querySelectorAll("img");
                    const modelImages = new Map();

                    for (const value of range.getWalker()) {
                      const item = value.item;
                      if (item.is("element", "imageBlock")) {
                        const src = item.getAttribute("src");
                        const alt = item.getAttribute("alt");
                        if (src) {
                          modelImages.set(src, alt || "");
                        }
                      }
                    }

                    images.forEach((img) => {
                      const src = img.getAttribute("src");
                      const alt = modelImages.get(src);
                      if (typeof alt === "string") {
                        img.setAttribute("alt", alt);
                      }
                    });

                    html = doc.body.innerHTML;
                    setContent(html);
                  }}
                  style={{
                    height: "500px",
                    width: "500px",
                  }}
                />
              </div>
              {submiteed ? (
                <div className="field cursor-pointer ">
                  <div className=" my-5 rounded-md bg-gray-300 py-3 px-12 text-white">
                    <button disabled>Loading....</button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="field cursor-pointer ">
                    {submiteed ? (
                      <>
                        <div className=" my-5 rounded-md bg-primaryBlue/30 py-3 px-12 text-white">
                          <button disabled>Loading...</button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          onClick={sendData}
                          className=" my-5 rounded-md bg-primaryBlue py-3 px-12 text-white"
                        >
                          <button>Submit</button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default BlogsForm;
